@if (!showResetPassword()) {
  <div class="forgot-password-page-container">
    <div class="forgot-password-container">
      <a class="back-button" routerLink="/login">
        <i class="bi bi-arrow-left"></i>
        Back
      </a>
      <div class="forgot-password-content">
        <div class="left-panel">
          <h1 class="main-title">Forgot Password</h1>
          <p class="subtitle">Whoops!</p>
        </div>
        <div class="right-panel">
          <h2 class="welcome-text">Whoops!</h2>
          <p class="forgot-password-instruction">Forgot your password?</p>
          <form (ngSubmit)="sendEmail()" #form="ngForm" autocomplete="off">
            <div class="form-group">
              <label for="email" class="visually-hidden">Email</label>
              <div class="input-with-icon">
                <i class="bi bi-envelope"></i>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="email"
                  [ngModel]="email()"
                  (ngModelChange)="email.set($event)"
                  placeholder="Email"
                  required
                  />
              </div>
            </div>
            @if (error()) {
              <div class="alert alert-danger mb-3">
                {{ error() }}
              </div>
            }
            <button
              class="btn btn-primary verify-email-btn"
              type="submit"
              [disabled]="!isSendEmailFormValid()"
              [ngClass]="{ 'disabled': loading() }"
              >
              @if (loading()) {
                <span
                  class="spinner-border spinner-border-sm"
                  aria-hidden="true"
                ></span>
              }
              <span class="ms-2" role="status">Send reset email</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
}

@if (showResetPassword()) {
  <div class="forgot-password-page-container">
    <div class="forgot-password-container">
      <div class="forgot-password-content">
        <div class="left-panel">
          <h1 class="main-title">Reset Password</h1>
          <p class="subtitle">to continue</p>
        </div>
        <div class="right-panel">
          <h2 class="welcome-text">Reset Password</h2>
          <p class="forgot-password-instruction">Reset your password</p>
          <form (ngSubmit)="resetPassword()" #form="ngForm" autocomplete="off">
            <div class="form-group">
              <label for="email" class="visually-hidden">Email</label>
              <div class="input-with-icon">
                <i class="bi bi-envelope"></i>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="email"
                  [ngModel]="email()"
                  (ngModelChange)="email.set($event)"
                  placeholder="Email"
                  required
                  />
              </div>
            </div>
            <div class="form-group">
              <label for="code" class="visually-hidden">Code</label>
              <div class="input-with-icon">
                <i class="bi bi-code"></i>
                <input
                  type="text"
                  class="form-control"
                  id="code"
                  name="code"
                  [ngModel]="code()"
                  (ngModelChange)="code.set($event)"
                  placeholder="Code"
                  required
                  />
              </div>
            </div>
            <div class="form-group">
              <label for="password" class="visually-hidden">Password</label>
              <div class="input-with-icon">
                <i class="bi bi-lock"></i>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  name="password"
                  [ngModel]="password()"
                  (ngModelChange)="password.set($event)"
                  placeholder="Password"
                  required
                  />
              </div>
              <p class="password-requirements-hint">{{ passwordRequirements }}</p>
              @if (showPasswordRequirementsWarning()) {
                <p class="password-requirements-warning" role="status">
                  Password must meet the requirements above.
                </p>
              }
            </div>
            @if (error()) {
              <div class="alert alert-danger mb-3">
                {{ error() }}
              </div>
            }
            <button
              class="btn btn-primary verify-email-btn"
              type="submit"
              [disabled]="!isResetPasswordFormValid()"
              [ngClass]="{ 'disabled': loading() }"
              >
              @if (loading()) {
                <span
                  class="spinner-border spinner-border-sm"
                  aria-hidden="true"
                ></span>
              }
              <span class="ms-2" role="status">Reset password</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
}